<template>
  <div class="plane-select-list" :class="{ isiOSX: isiOSX }">
    <van-row class="detailTitle">
      <img @click="reBack" class="back" src="../../assets/plane/reBack.png" />
      <van-col class="target" span="24">
        {{ departure }}
        <img src="../../assets/plane/target@2x.png" />
        {{ destination }}
      </van-col>
    </van-row>
    <div class="wrapper">
      <div class="more" @click="moreDate()">
        <p class="calendar">
          <img src="../../assets/plane/calendar.png" />
        </p>
        <p class="middle">更多</p>
        <p class="bottom">日期</p>
      </div>
      <div class="datePrice">
        <ul class="clearfix">
          <li
            v-for="(item, index) in lists"
            :key="index"
            @click="changeRed(index, item.date)"
            :class="[activeIndex == index ? 'active' : '']"
          >
            <!-- <li v-for="(item,index) in lists" :key="index" @click="changeRed(item)" :class="[item.active ? 'active':'']"> -->
            <span class="week">{{ day(item) }}</span>
            <span class="date">{{ item.date.substring(5) }}</span>
            <span class="price">{{ item.price }}</span>
          </li>
          <li class="empty">0</li>
        </ul>
      </div>
    </div>
    <div class="plane_list">
      <div class="box" v-if="select_lists.length > 0">
        <van-row
          class="list"
          v-for="(price_item, index) in select_lists"
          :key="index"
        >
          <div @click="enterDetail(price_item)" style="height: 113px">
            <van-col span="24">
              <p class="time">
                {{ price_item.departure_time }}
                <span class="hour">
                  <span>{{ price_item.flight_time1 }}</span>
                  <img src="../../assets/plane/targetL@2x.png" />
                  <span
                    class="label"
                    v-if="
                      price_item.stop_num != 0 &&
                      price_item.stop_points[0] &&
                      !price_item.stop_points[0].flight_no1
                    "
                    >经停</span
                  >
                  <span
                    class="label"
                    v-if="
                      price_item.stop_num != 0 &&
                      price_item.stop_points[0] &&
                      price_item.stop_points[0].flight_no1
                    "
                    >通程</span
                  >
                </span>
                {{ price_item.arrive_time }}
              </p>
              <p class="address">
                <span class="left">{{
                  price_item.departure_port_came + price_item.departure_terminal
                }}</span>
                <span class="right">{{
                  price_item.arrive_port_name + price_item.arrive_terminal
                }}</span>
              </p>
              <p class="planeMsg">
                <img :src="price_item.air_comImage_url" />
                {{ price_item.airline_company + price_item.flight_no }}
                <span class="line"></span>
                {{ price_item.craft_type_name || price_item.craft_type }}
                <span v-if="price_item.plane_model"
                  >(<span v-if="price_item.plane_model == 1">大</span
                  ><span v-if="price_item.plane_model == 2">中</span
                  ><span v-if="price_item.plane_model == 3">小</span
                  ><span v-if="price_item.plane_model == 0">其他</span>)</span
                >
                <span v-else>(其他)</span>
              </p>
            </van-col>
          </div>
          <van-col class="editor">
            <p class="price" @click="enterDetail(price_item)">
              ￥
              <span>{{ price_item.price }}</span
              >起
              <!-- <span class="label">返</span> -->
            </p>
            <p class="reback" @click="enterDetail(price_item)">
              <span class="child" v-if="child_show">
                儿童
                <span
                  v-for="(item, index) in price_item.price_list"
                  :key="index"
                >
                  <span v-if="item.psg_type == 'CHD'"> ￥{{ item.price }}</span>
                </span>
              </span>
            </p>
            <p class="reback" @click="enterDetail(price_item)">
              <span class="child" v-if="baby_show">
                婴儿
                <span
                  v-for="(item, index) in price_item.price_list"
                  :key="index"
                >
                  <span v-if="item.psg_type == 'INF'">￥{{ item.price }}</span>
                </span>
              </span>
            </p>
            <p class="collection">
              <span
                @click="collect(price_item)"
                :class="price_item.collection ? 'dislike' : 'like'"
                >{{ price_item.collection ? "已收藏" : "收藏" }}</span
              >
            </p>
          </van-col>
        </van-row>
      </div>
      <div class="box loading" v-if="select_lists.length <= 0 && hasOrder">
        <img src="../../assets/common/loading.gif" />
      </div>
      <van-row class="empty_list" v-if="!hasOrder">
        <van-col class="emptyMsg" span="24">
          <img src="../../assets/plane/noOrder.png" />
          <p class="tip1" v-if="!timeout">暂无相关航班</p>
          <p class="tip1" v-if="timeout"></p>
          <p class="btn">
            <span @click="reBack">返回</span>
          </p>
        </van-col>
      </van-row>
    </div>
    <van-tabbar>
      <van-tabbar-item @click="time">
        <span class="active" v-if="timeSort">时间排序</span>
        <span v-if="!timeSort">时间排序</span>
        <img slot="icon" :src="time_img" />
      </van-tabbar-item>
      <van-tabbar-item @click="price">
        <span class="active" v-if="priceSort">价格排序</span>
        <span v-if="!priceSort">价格排序</span>
        <img slot="icon" :src="price_img" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import timeImg from "@/assets/plane/time.png";
import timeImg_1 from "@/assets/plane/time_1.png";
import priceImg from "@/assets/plane/price.png";
import priceImg_1 from "@/assets/plane/price_1.png";

export default {
  data() {
    return {
      departure: "",
      destination: "",
      departure_date: "",
      like: false,
      timeSort: false,
      priceSort: false,
      time_img: timeImg_1,
      price_img: priceImg_1,
      lists: [],
      lists_canlendar: [],
      activeIndex: "",
      select_lists: [],
      adult_lists: [],
      child_show: false,
      baby_show: false,
      resource_party: "",
      afterDay: [],
      isiOSX: false,
      channelCount: 0,
      time_Sort: false,
      price_Sort: false,
      hasOrder: true,
      timeout: false,
    };
  },
  created: function () {
    //created:在模板渲染成html前调用，即通常初始化某些属性值，然后再渲染成视图。
    this.isiOSX = this.isIphoneX();
  },
  methods: {
    /**
     * 计算2个日期相差的天数，不包含今天，如：2016-12-13到2016-12-15，相差2天
     * @param startDateString
     * @param endDateString
     * @returns
     */
    dateDiff(startDateString, endDateString) {
      var separator = "-"; //日期分隔符
      var startDates = startDateString.split("-");
      var endDates = endDateString.split("-");
      var startDate = new Date(startDates[0], startDates[1] - 1, startDates[2]);
      var endDate = new Date(endDates[0], endDates[1] - 1, endDates[2]);
      return parseInt(Math.abs(endDate - startDate) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
    },
    getDate(n) {
      var ss = 24 * 60 * 60 * 1000; //一天的毫秒数86400
      var timestamp = new Date().getTime(); //获取当前时间戳
      var date1 = new Date(ss * n + timestamp); //加上n天的国际标准日期
      var arr =
        date1.getFullYear() +
        "/" +
        (date1.getMonth() + 1) +
        "/" +
        date1.getDate(); //把2018/6/4提取出来
      var arr2 = arr.split("/"); //把年月日数字单独提出来
      return (
        arr2[0] + "-" + this.checkTime(arr2[1]) + "-" + this.checkTime(arr2[2])
      ); //拼接成我们需要的格式返回
    },
    //点击变红
    changeRed(params, date) {
      this.hasOrder = true;
      this.channelCount = 0;
      this.activeIndex = params;
      this.departure_date = date;
      this.select_lists = [];
      this.searchList(this.$route.query);
      // this.lists = this.lists.map(_ => {
      // 	_.active && delete _.active;
      // 	if(_ == params){
      // 		_.active = true;
      // 	}
      // 	return _;
      // })
    },
    //点击进入日历
    moreDate() {
      this.$router.replace({
        //路由跳转
        path: "/plane/calendar",
        query: {
          departure: this.$route.query.departure,
          destination: this.$route.query.destination,
          child_quantity: this.$route.query.child_quantity,
          baby_quantity: this.$route.query.baby_quantity,
          departure_date: this.departure_date,
          cabin: this.$route.query.cabin,
          from: 2, //表示来自列表页
          departure_city: this.$route.query.departure_city,
          arrive_city: this.$route.query.arrive_city,
        },
      });
    },
    //点击进入机票详情
    enterDetail(item) {
      item.cabin = this.$route.query.cabin;
      item.child_quantity = this.$route.query.child_quantity;
      item.baby_quantity = this.$route.query.baby_quantity;
      sessionStorage.setItem("planes", JSON.stringify(item));
      this.$router.push("/plane/detail");
    },
    reBack() {
      this.$router.go(-1);
    },
    //收藏航班
    collect(item) {
      if (item.collection == 0) {
        var flight_no1, flight_no2;
        if (item.stop_num == 0) {
          flight_no1 = "";
          flight_no2 = "";
        } else {
          flight_no1 = item.stop_points[0].flight_no1;
          flight_no2 = item.stop_points[0].flight_no2;
        }
        this.$api
          .post("/air/member/booking/add/collection", {
            depart_city_code: item.departure_port_iata_code, //类型：String  必有字段  备注：出发城市三字码
            arrive_city_code: item.arrive_port_iata_code, //类型：String  必有字段  备注：抵达城市三字码
            depart_city: item.departure_city_name, //类型：String  必有字段  备注：出发城市
            arrive_city: item.arrive_city_name, //类型：String  必有字段  备注：抵达城市
            depart_airport_name: item.departure_port_came, //类型：String  必有字段  备注：出发机场名称
            arrive_airport_name: item.arrive_port_name, //类型：String  必有字段  备注：到达机场名称
            flight_no: item.flight_no, //类型：String  必有字段  备注：航班号
            airplane_name: item.craft_type, //类型：String  必有字段  备注：飞机名称
            departure_time: item.departure_time, //类型：String  必有字段  备注：出发时间
            arrive_time: item.arrive_time, //类型：String  必有字段  备注：抵达时间
            company_name: item.airline_company, //类型：String  必有字段  备注：航空公司名称
            resource_party: this.resource_party, //类型：String  必有字段  备注：服务商
            flight_time: this.transform(item.flight_time),
            plane_model: item.plane_model,
            stop_num: item.stop_num,
            flight_no1: flight_no1,
            flight_no2: flight_no2,
            departure_date: item.departure_date,
          })
          .then((res) => {
            item.collection = res.id;
            //重新给数组赋值，让他刷新
            this.select_lists = [...this.select_lists];
          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            //this.$toast(message);
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          });
      } else {
        this.$api
          .post("/air/member/booking/cancel/collection", {
            id: item.collection,
          })
          .then((res) => {
            item.collection = 0;
            //重新给数组赋值，让他刷新
            this.select_lists = [...this.select_lists];
          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            //this.$toast(message);
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          });
      }
    },
    transform(time) {
      var hh = Math.floor(time / 60);
      var mm = time - hh * 60;
      return this.checkNumber(hh) + ":" + this.checkNumber(mm);
    },
    checkNumber(num) {
      if (num < 10) {
        return "0" + num;
      } else {
        return num;
      }
    },
    time() {
      this.timeSort = true;
      this.priceSort = false;
      this.time_Sort = !this.time_Sort;
      let time_Sort = !this.time_Sort;
      this.time_img = timeImg;
      this.price_img = priceImg_1;
      //时间排序
      this.select_lists.sort(function (a, b) {
        let _a = parseInt(a.departure_time.replace(":", "")),
          _b = parseInt(b.departure_time.replace(":", ""));
        if (time_Sort) {
          return _a - _b;
        } else {
          return _b - _a;
        }
      });
    },
    price() {
      this.timeSort = false;
      this.priceSort = true;
      this.price_Sort = !this.price_Sort;
      let price_Sort = !this.price_Sort;
      this.time_img = timeImg_1;
      this.price_img = priceImg;
      //价格排序
      this.select_lists.sort(function (a, b) {
        if (price_Sort) {
          return a.price - b.price;
        } else {
          return b.price - a.price;
        }
      });
    },
    //获取日历价格
    dataPrice({ departure, destination, departure_date }) {
      this.$api
        .post("/air/member/booking/calendar", {
          arrive_city_code: destination,
          depart_city_code: departure,
          departure_date: departure_date,
        })
        .then((res) => {
          this.lists_canlendar = res.list.slice(0, 15);
          // this.lists[0].active = true;
          //选择的日期和今天相差的天数
          if (this.$route.path == "/select/list") {
            var diff = this.dateDiff(
              this.getDate(0),
              this.$route.query.departure_date
            );
            let maxDiff = Number(diff) + 14;
            for (let i = diff; i <= maxDiff; i++) {
              var dateObj = {};
              dateObj.price = "";
              dateObj.date = this.getDate(i); //把返回的日期赋值给对象
              this.afterDay.push(dateObj); //把对象添加到数组里面，然后渲染到页面
            }
            for (let i in this.afterDay) {
              for (let j in this.lists_canlendar) {
                if (this.lists_canlendar[j].date == this.afterDay[i].date) {
                  this.afterDay[i].price = "￥" + this.lists_canlendar[j].price;
                }
              }
            }
            this.lists = this.afterDay;
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    //设置获取的日期对应的星期
    day(a) {
      let week;
      let b = new Date(a.date);
      var c = b.getDay();
      switch (c) {
        case 1:
          week = "周一";
          break;
        case 2:
          week = "周二";
          break;
        case 3:
          week = "周三";
          break;
        case 4:
          week = "周四";
          break;
        case 5:
          week = "周五";
          break;
        case 6:
          week = "周六";
          break;
        default:
          week = "周日";
      }
      return week;
    },
    //搜索结果数据
    searchList({
      departure,
      destination,
      child_quantity,
      baby_quantity,
      //    departure_date,
      cabin,
    }) {
      this.$api
        .post("/air/member/booking/flight/list", {
          adult_quantity: 1,
          channel_count: this.channelCount,
          child_quantity: child_quantity,
          baby_quantity: baby_quantity,
          arrive_city_code: destination,
          departure_date: this.departure_date,
          depart_city_code: departure,
          cabin_class: cabin,
        })
        .then((res) => {
          if (res.list.flight_list.length == 0) {
            this.hasOrder = false;
          }

          sessionStorage.setItem("query_id", res.list.query_id);
          this.resource_party = res.resource_party;
          this.channelCount = res.list.channel_count;
          res.list.flight_list.forEach((ele) => {
            //修改飞行时长样式
            //          var dur = ele.journey_info_list[0][0].duration;
            var h = Math.floor(ele.flight_time / 60);
            var minit = ele.flight_time - h * 60;
            ele.flight_time1 = h + "小时" + minit + "分";
          });

          this.select_lists = res.list.flight_list;
          if (res.list.flight_list[0]) {
            //找出当天的最低价格
            var minP = this.select_lists[0].price;
            for (let i in this.select_lists) {
              var currentP = this.select_lists[i].price;
              if (currentP < minP) {
                minP = currentP;
              }
            }
            for (let i in this.lists) {
              if (this.lists[i].date == this.departure_date) {
                this.lists[i].price = "￥" + minP;
              }
            }
          }

          window.scrollTo(0, 1);
        })
        .catch((err) => {
          this.hasOrder = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
            this.timeout = true;
          } else {
            this.$toast(message);
          }
        });
    },
    //提示
    tips() {
      this.$dialog
        .alert({
          title: "出行提示",
          messageAlign: "left",
          message:
            "受新冠疫情影响，各地的防控政策调整频繁，请出行前务必与出发地以及目的地的疫情管控单位确认核酸检测报告时限要求以及落地管控政策，合理安排出行。",
          confirmButtonText: "确定",
          confirmButtonColor: "#f9591b",
        })
        .then(() => {});
    },
  },
  mounted() {
    this.departure = this.$route.query.departure_city;
    this.destination = this.$route.query.arrive_city;
    //调用日历价格
    this.departure_date = this.$route.query.departure_date;
    this.dataPrice(this.$route.query);
    this.searchList(this.$route.query);
    if (this.$route.query.child_quantity == "0") {
      this.child_show = false;
    } else {
      this.child_show = true;
    }
    if (this.$route.query.baby_quantity == "0") {
      this.baby_show = false;
    } else {
      this.baby_show = true;
    }
    this.tips();
  },
};
</script>

<style lang="less" scoped>
.plane {
  &-select-list {
    height: 100%;
    background: #f2f2f2;
    .detailTitle {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
      padding: 0;
      width: 100%;
      padding-top: 24px;
      height: 50px;
      line-height: 50px;
      background: #f2f2f2;
      .back {
        width: 17px;
        padding: 8px;
        position: fixed;
        top: 39px;
        left: 8px;
        z-index: 9;
      }
      .target {
        padding: 6px 16px;
        text-align: center;
        img {
          width: 30px;
          padding: 5px 6px;
        }
      }
    }
    .wrapper {
      width: 100%;
      overflow: hidden;
      position: fixed;
      top: 70px;
      left: 0;
      z-index: 10;
      .datePrice {
        width: 100%;
        overflow-x: scroll;
        .clearfix {
          width: 903px;
          overflow-y: hidden;
          white-space: nowrap;
          li {
            width: 56px;
            height: 63px;
            float: left;
            background: #ffffff;
            font-size: 13px;
            text-align: center;
            border-right: solid 1px #e3e3e3;
            span {
              display: block;
              width: 100%;
            }
            .week {
              width: 56px;
              line-height: 23px;
              margin: 0;
            }
            .date {
              line-height: 15px;
              margin: 0;
            }
            .price {
              line-height: 24px;
              margin: 0;
            }
          }
          .active {
            color: #fff;
            background: #e6212f;
          }
          .empty {
            width: 1px;
            padding-right: 46px;
            color: rgba(0, 0, 0, 0);
            background: rgba(0, 0, 0, 0);
          }
        }
        .clearfix::after {
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 1;
          width: 100%;
          height: 100px;
          content: "";
          display: none;
        }
      }
      .more {
        color: #e6212f;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 2;
        background: #fff;
        font-size: 13px;
        height: 63px;
        text-align: center;
        box-shadow: #e3e3e3 -2px 0px 4px;
        p {
          width: 49px;
          img {
            width: 20px;
            margin-top: 3px;
            display: inline-block;
          }
        }
        .calendar {
          height: 21px;
          line-height: 21px;
          margin: 0;
        }
        .middle {
          line-height: 26px;
          margin: 0;
        }
        .bottom {
          line-height: 12px;
          margin: 0;
        }
      }
    }
    .plane_list {
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .box {
        background: #f2f2f2;
        padding: 137px 11px 57px;
        .list {
          background: #fff;
          border-radius: 10px;
          padding: 0 10px 0 11px;
          box-shadow: #e3e3e3 2px 0 4px;
          color: #666;
          font-size: 13px;
          margin-top: 7px;
          position: relative;
          .time {
            color: #333;
            font-size: 21px;
            height: 21px;
            line-height: 21px;
            margin-top: 24px;
            .hour {
              width: 60px;
              height: 21px;
              text-align: center;
              padding: 0 14px;
              display: inline-block;
              color: #999;
              font-size: 9px !important;
              position: relative;
              img {
                width: 59px;
                margin-bottom: 6px;
                display: inline-block;
              }
              span {
                position: absolute;
                top: -11px;
                left: 0;
                width: 100%;
              }
              .label {
                top: 7px;
              }
            }
            @media screen and (max-width: 320px) {
              .hour {
                padding: 0 5px;
              }
            }
          }
          .address {
            height: 20px;
            line-height: 20px;
            span {
              float: left;
            }
            .left {
              width: 142px;
            }
            @media screen and (max-width: 320px) {
              .left {
                width: 132px;
              }
            }
          }
          .planeMsg {
            height: 48px;
            line-height: 48px;
            img {
              width: 14px;
              margin-right: 7px;
              float: left;
              margin-top: 16px;
            }
            .line {
              width: 1px;
              height: 10px;
              background: #666;
              margin: 0 7px;
              display: inline-block;
            }
          }
          .editor {
            position: absolute;
            top: 0;
            right: 10px;
            padding-top: 23px;
            text-align: right;
            .price {
              color: #e6212f;
              font-size: 14px;
              height: 24px;
              line-height: 24px;
              span {
                font-size: 21px;
              }

              .label {
                text-align: center;
                border-radius: 3px;
                margin-left: 7px;
                color: #333;
                padding: 2px;
                background: #ffc663;
                font-size: 11px !important;
              }
            }
            @media screen and (max-width: 320px) {
              .price {
                font-size: 12px;
                span {
                  font-size: 18px;
                }
              }
            }
            .reback {
              height: 16px;
              line-height: 16px;
              .child {
                span {
                  color: #e6212f;
                  margin-left: 3px;
                }
              }
            }
            .collection {
              height: 19px;
              line-height: 19px;
              /*margin-top: 12px;*/
              margin-top: 6px;
              .like {
                width: 44px;
                height: 19px;
                display: inline-block;
                color: #fff;
                padding-right: 8px;
                text-align: right;
                font-size: 11px;
                background: url(../../assets/plane/like.png) no-repeat center
                  center;
                background-size: 100% 100%;
              }
              .dislike {
                width: 52px;
                height: 19px;
                display: inline-block;
                color: #e6212f;
                text-align: center;
                border: solid 1px #e6212f;
                border-radius: 10px;
              }
            }
          }
        }
        @media screen and (max-width: 320px) {
          .list {
            font-size: 12px;
          }
        }
      }
      .loading {
        text-align: center;
        img {
          width: 35%;
          margin-top: 50%;
        }
      }
      .empty_list {
        padding-top: 202px;
        .emptyMsg {
          padding: 0 93px;
          text-align: center;
          img {
            width: 100%;
            display: block;
          }
          .tip1 {
            color: #b9b9b9;
            font-size: 15px;
            height: 51px;
            line-height: 51px;
            margin-bottom: 12px;
          }
          .btn {
            text-align: center;
            span {
              width: 110px;
              height: 32px;
              line-height: 32px;
              color: #ff6059;
              display: inline-block;
              border: solid 1px rgba(255, 96, 89, 0.4);
              border-radius: 16px;
              box-shadow: rgba(255, 96, 89, 0.1) 3px 0 6px;
            }
          }
        }
      }
    }
    .van-tabbar {
      height: 49px;
      .van-tabbar-item {
        color: #666;
        font-size: 11px !important;
        .active {
          color: #e6212f;
        }
      }
    }
  }
}
.isiOSX {
  .detailTitle {
    padding-top: 44px;
    .back {
      top: 59px;
    }
  }
  .wrapper {
    top: 94px;
  }

  .plane_list {
    .box {
      padding-top: 157px;
    }
  }
}
</style>
